import { Navigate } from "react-router-dom";
import { useRequireAuth } from "@/lib/auth";
import HomeScreen from "./HomeScreen";
import FieldMobileHome from "./FieldMobileHome";
import KioskHome from "@/features/kiosk/KioskHome";

// =============================================================================
// RootHome — `/` landing router by role.
//
// T-061 + T-074 + T-154:
//   subcontractor (Supplier subbie)            → /profile (locked-down portal —
//     no projects, no bookings, no commercial. Their nav is just Profile +
//     Licences. Labour subbies are role=field after onboarding so they fall
//     into the field branch below, not here.)
//   field / supervisor → FieldMobileHome (slim, mobile-first "today's site"
//     hero + bookings + licence warnings).
//   manager / director → HomeScreen (full company-wide command surface).
//
// Old PortalHome (mid-detail, two-column desktop layout) remains accessible
// at /portal explicitly.
// =============================================================================
export default function RootHome() {
  const user = useRequireAuth();
  if (!user) return null;
  if (user.role === "subcontractor") {
    return <Navigate to="/profile" replace />;
  }
  // mig 410 — the crew tablet: site folders first, nothing personal.
  if (user.role === "kiosk") {
    return <KioskHome />;
  }
  if (user.role === "field" || user.role === "supervisor") {
    return <FieldMobileHome />;
  }
  return <HomeScreen />;
}
